<div
  class="form_field-wrapper"
  [ngClass]="{
    'form_field-wrapper--error': control.invalid && control.touched,
    'form_field-wrapper--indent': isIndent,
    'form_field-wrapper--large-spacing': useLargeSpacing
  }"
  (click)="onInputClick()">
  @if ((placeholderBold || placeholderThin)) {
    <label
      [for]="identifier"
      class="form_placeholder"
    [ngClass]="{
      'form_placeholder--disabled': control.disabled, 
      'form_placeholder--minimized': forceMinimized || placeholderMinimized || control.value || control.disabled || control.errors?.validatePhoneNumber,
      'form_placeholder--offset': hasPlaceholderOffset
    }">
      <strong>{{ placeholderBold }}</strong><span class="faded">{{ placeholderThin }}</span>
    </label>
  }
  @if (infoIconText) {
    <i
      class="form_info-icon fa fa-info-circle"
      [ngClass]="{'form_info-icon--checkbox': infoIconCheckbox }"
      [matTooltip]="infoIconText">
    </i>
  }
  <ng-content></ng-content>

  @if (control.errors?.required && !control.errors?.validatePhoneNumber && control.touched) {
    <small aria-label="required_error" class="form_error"
      name="required_error" role="alert">
      {{ label }} {{ 'isRequired' | translate }}.
    </small>
  }

  @if (control.errors?.email && control.touched) {
    <small aria-label="email_error" class="form_error" name="email_error"
      role="alert">
      {{ 'notValidEmail' | translate }}
    </small>
  }

  @if (control.errors?.pattern && !control.errors?.minlength && control.touched) {
    <small aria-label="pattern_error" class="form_error"
      name="pattern_error" role="alert">
      {{ 'notValidValue' | translate }}
    </small>
  }

  @if (control.errors?.notEquivalent && control.touched) {
    <small aria-label="not_match_error" class="form_error"
      name="not_match_error" role="alert">
      {{ 'passwordsDontMatch' | translate }}
    </small>
  }

  @if (control.errors?.usernameTaken && control.touched) {
    <small aria-label="not_match_error" class="form_error"
      name="username_taken_error" role="alert">
      {{ 'usernameInUse' | translate }}
    </small>
  }

  @if (control.errors?.emailTaken && control.touched) {
    <small aria-label="not_match_error" class="form_error"
      name="email_taken_error" role="alert">
      {{ 'emailInUse' | translate }}
    </small>
  }

  @if (control.errors?.ssoIdTaken && control.touched) {
    <small aria-label="sso_id_taken_error" class="form_error"
      name="sso_id_taken_error" role="alert">
      {{ 'ssoIdInUse' | translate }}
    </small>
  }

  @if (control.errors?.phoneTaken && control.touched) {
    <small aria-label="not_match_error" class="form_error"
      name="phone_taken_error" role="alert">
      {{ 'phoneInUse' | translate }}
    </small>
  }

  @if (control.errors?.maxFileCount && control.touched) {
    <small aria-label="max_file_count" class="form_error"
      name="max_file_size" role="alert">
      {{ 'maxFileCount' | translate }}
    </small>
  }

  @if (control.errors?.maxFileSize && control.touched) {
    <small aria-label="max_file_size" class="form_error"
      name="max_file_size" role="alert">
      {{ 'maxFileSize' | translate }}
    </small>
  }

  @if (control.errors?.fileNotAllowed && control.touched) {
    <small aria-label="file_not_allowed" class="form_error"
      name="file_not_allowed" role="alert">
      {{ 'fileTypeNotAllowed' | translate }}
    </small>
  }

  @if (control.errors?.max && control.touched) {
    <small aria-label="maximum_number_value" class="form_error form_error--large"
      name="maximum_number_value" role="alert">
      {{ 'maximumFieldNumberMessage' | translate }} {{control.errors.max?.max}}.
    </small>
  }

  @if (control.errors?.min && control.touched) {
    <small aria-label="minimum_number_value" class="form_error form_error--large"
      name="minimum_number_value" role="alert">
      {{ 'minimumFieldNumberMessage' | translate }} {{control.errors.min?.min}}.
    </small>
  }

  @if (control.errors?.maxlength && control.touched) {
    <small aria-label="maximum_input_length" class="form_error form_error--large"
      name="maximum_input_length" role="alert">
      {{ 'maximumInputLengthMessage' | translate }} {{control.errors.maxlength?.requiredLength}}.
    </small>
  }

  @if (control.errors?.minlength && control.touched) {
    <small aria-label="minimum_input_length" class="form_error form_error--large"
      name="minimum_input_length" role="alert">
      {{ 'minimumInputLengthMessage' | translate }} {{control.errors.minlength?.requiredLength}}.
    </small>
  }

  @if (control.errors?.invalidDateRange && control.touched) {
    <small aria-label="invalid_date_range" class="form_error form_error--large"
      name="invalid_date_range" role="alert">
      {{ 'invalidDateRange' | translate }}
    </small>
  }

  @if (control.errors?.validatePhoneNumber && control.touched) {
    <small aria-label="invalid_phone_number" class="form_error"
      name="invalid_phone_number" role="alert">
      {{ 'invalidPhoneNumber' | translate }}
    </small>
  }

  @if (control.errors?.countryInvalid && control.touched) {
    <small aria-label="invalid_country" class="form_error"
      name="invalid_cuntry" role="alert">
      {{ 'invalidCountry' | translate }}
    </small>
  }

  @if ((control.errors?.matDatepickerMin || control.errors?.minDate) && control.touched) {
    <small aria-label="invalid_minimum_date" class="form_error"
      name="invalid_minimum_date" role="alert">
      {{ 'minimumDateMessage' | translate }}
    </small>
  }

  @if (control.errors?.matDatepickerMax && control.touched) {
    <small aria-label="invalid_maximum_date" class="form_error"
      name="invalid_maximum_date" role="alert">
      {{ 'maximumDateMessage' | translate }}
    </small>
  }
</div>